




























import Vue from 'vue'
import CatalogInstanceDetailsStore from '@/store/catalog/catalogInstanceDetails'
import MappingInformation from '@/views/components/catalog/catalogInstanceDetails/mappingInformation.vue'
import ImportInformation from '@/views/components/catalog/catalogInstanceDetails/importInformation.vue'

export default Vue.extend({
  name: 'CatalogInstanceVue',
  components: {
    MappingInformation,
    ImportInformation,
  },
  mounted() {
    CatalogInstanceDetailsStore.dispatch('getCatalogInstanceDetails', this.$route.params.catalogId)
  },

})
